'use strict';

var DURATION_UNITS = require('./DURATION_UNITS');

module.exports = '((?:\\d+)?\\s*(?:' + DURATION_UNITS + '))s?';


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/range/var/FULL_CAPTURED_DURATION.js
// module id = 1668
// module chunks = 0